import type { ConceptDef } from '../types';

export const imitateOralMotor: ConceptDef = {
  kind: 'supervisorScored',
  id: 'imitate-oral-motor',
  label: 'Imitate Oral Motor',
  category: 'Motor imitation',
  description: 'Model an oral-motor action; learner imitates. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Blow a kiss.' },
      { prompt: 'Stick out your tongue.' },
      { prompt: 'Smile wide.' },
      { prompt: 'Pucker your lips.' },
      { prompt: 'Click your tongue.' },
    ],
  },
};
